import { Injectable } from '@angular/core';

declare var gtag;

@Injectable({
  providedIn: 'root',
})
export class TribuneAnalyticsService {
  constructor() {}

  analyticTribuneVisited() {
    gtag('event', 'tribune_visited', {
      event_category: 'Tribune Events',
    });
  }

  analyticTribuneUsernameSet() {
    gtag('event', 'tribune_username_set', {
      event_category: 'Tribune Events',
    });
  }

  analyticTribuneAvatarChanged(status: string) {
    let json: JSON;
    let obj: any = {
      status: status,
    };
    json = <JSON>obj;
    gtag('event', 'tribune_avatar_changed', {
      event_category: 'Tribune Events',
      event_label: JSON.stringify(json),
    });
  }

  analyticTribuneLiked() {
    gtag('event', 'tribune_liked', {
      event_category: 'Tribune Events',
    });
  }

  analyticTribuneLikeDeleted() {
    gtag('event', 'tribune_like_deleted', {
      event_category: 'Tribune Events',
    });
  }

  analyticTribuneCommented() {
    gtag('event', 'tribune_commented', {
      event_category: 'Tribune Events',
    });
  }

  analyticTribuneCommentDeleted() {
    gtag('event', 'tribune_comment_deleted', {
      event_category: 'Tribune Events',
    });
  }

  analyticTribunePostReported() {
    gtag('event', 'tribune_post_reported', {
      event_category: 'Tribune Events',
    });
  }

  analyticTribuneCommentReported() {
    gtag('event', 'tribune_comment_reported', {
      event_category: 'Tribune Events',
    });
  }

  analyticTribuneHashtagClicked() {
    gtag('event', 'tribune_hashtag_clicked', {
      event_category: 'Tribune Events',
    });
  }

  analyticTribuneSearched() {
    gtag('event', 'tribune_searched', {
      event_category: 'Tribune Events',
    });
  }

  analyticTribuneSearchResultClicked() {
    gtag('event', 'tribune_search_result_clicked', {
      event_category: 'Tribune Events',
    });
  }
}
